module.exports = __webpack_public_path__ + "static/media/lock_circle_yellow.a6238950.svg";